import React, { Component } from 'react';
// import Modal from 'react-modal';
import PropTypes from 'prop-types';
import "./nav.css"
// import Header from './statics/header';

//  import Footer from './statics/footer';


const NavbarItem = props => (
    <a className="navbar-burger burger" href={`#${props.page}`}>
      {props.page}
    </a>
  );
  const NavbarBurger = props => (
    <a
      onClick={props.toggleMenu}
      className={`navbar-burger burger ${props.active ? 'is-active' : ''}`}
    >
      <span />
      <span />
      <span />
    </a>
  );

class  Navbar extends Component {
    constructor(props) {
      super(props);
      this.state = {
        activeMenu: false,
        hover:false,
        search:false,
        navcheck:true,
        className: "navbar  is-fixed-top nav-class-costom",
        linkclass:"is-light  nav-link-contom-login",
        profile:false,
        showModal:false,
        shareMadal:false,
        showArticle:false,
        WhichData:false,
        MethodData:false,
        single:false,
        everyone:false
        }
 
      }


      componentDidMount(){
        window.addEventListener("scroll", this.handleScroll);
      }

      handleHover() {
        this.setState({hover: !this.state.hover});
        
      }


      handleScroll=()=>{
        if (window.pageYOffset > 0) {
            if(this.state.  navcheck === false ){
              this.setState({ 
                className: "navbar is-info is-fixed-top",
                navcheck:true,
                linkclass:"is-light nav-link-contom"
               });   
              console.log("nav ----------------> show 0",)
            }
        }else{
            if(this.state.navcheck== true){
              this.setState({
                 className: "navbar  is-fixed-top nav-class-costom",
                 navcheck:false,
                 linkclass:"is-light  nav-link-contom-login "
                 });
              console.log("nav ----------------> show add",)
            }
        }
       
      }

  
   state = {
    activeMenu: false,
  };

  showProfile=(e)=>{
    e.preventDefault(); 
    this.setState({
      profile:!this.state.profile
    })
  }

  closeSearch = (e)=>{
    e.preventDefault(); 
    this.setState({
      search:!this.state.search
    })
  }
  
  showSearch = (e)=>{
    e.preventDefault(); 
    this.setState({
      search:!this.state.search
    })
  }

  closeVendors=(e)=>{
    this.setState({
      showModal:false,
      shareMadal:false,
      showQuiz:false,
      showArticle :false,
    })
  }

  toggleMenu = () => {
    this.setState({
      activeMenu: !this.state.activeMenu,
    });
    // this.toggleMenuProp()
  };

  clickModal=()=>{
    this.setState({
      showModal:true
    })
  }

  clickShare=()=>{
    this.setState({
      shareMadal:true
    })
  }

  clickQuiz=()=>{
    this.setState({
      showQuiz :true,
      showArticle :false,
    })
  }

  clickArtilce=()=>{
    this.setState({
      showArticle :true,
      showQuiz :false
    })
  }

  seleteWhich=()=>{
    this.setState({
      WhichData:true

    })
  }

  clickMethod = ()=>{
    this.setState({
      MethodData:true

    })
  }

  clickSingle=()=>{
    this.setState({
       single:true,
       singleDATA:[]
    })
  }

  clickEveryone=()=>{
    this.setState({
      everyone:true,
      EveryoneDATA:[]
   })
  }

  toggleMenuProp=()=>{
    this.props.sendtoggleMenu(this.state.activeMenu)
   }

  render() {
    console.log("hover and leave==============->", this.state.loginNav)
    let { pages = [], color="is-dark" } = this.props;
    let navbarItems = pages.map(page => <NavbarItem page={page} key={page} />);
    return (
      
     <div>
          {
            !this.props.loginNav?
            <div>
            {
                this.state.activeMenu?
                   
                    <div className="" > 
                          <div className="moblieside-fullbody-sub">
                              <div      style={{position:"relative",bottom:"20px",float:"right",height:"2px"}}>
                                <a
                                onClick={this.toggleMenu}
                                style={{position:"relative",bottom:"3%",}}
                                className={`navbar-burger burger ${this.state.activeMenu ? 'is-active' : ''}`}
                                    >
                          
                                    
                                    <span />
                                    <span />
                                    <span />
                                </a>
                              </div>
                               
                              <img src="https://res.cloudinary.com/easywaya/image/upload/v1598952836/Codepally_Icon_ffeh0c.png" width="50" 
                                style={{position:"relative",bottom:"6px",left:"27px"}}
                              /> 
                             
                              <div className="nav-list-link">
                               <a href="/" > <p>Home</p>   </a>
                              </div>
                              
                              
                              <div className="nav-list-link">
                              <a href="#"> <p> SCHOOL</p> </a>
                              </div>
                              <div className="nav-list-link">
                              <a href="#" >  <p>CONTACT</p> </a>
                              </div>
                               
  
  
                         </div>
                      </div>
                      :
                      <nav   className={this.state.className} role="navigation" aria-label="main navigation" >
          
                      <div class="navbar-brand" >
                        <a class="navbar-item  navbar-item-img-cos" href="/">
                        
                          <img src="https://res.cloudinary.com/easywaya/image/upload/v1598952836/Codepally_Icon_ffeh0c.png" width="" height=""/>
                        </a>
                        <NavbarBurger
                          active={this.state.activeMenu}
                          toggleMenu={this.toggleMenu}
                        />
                        
                      </div>
                      
                      <div id="navbarBasicExample " class="navbar-menu nav-constom">
                        <div class="navbar-start">
                          
                          <a href="/" class="nav-pay-quiz">
                             START QUIZ
                          </a>
              
                          <a   href="#" class="nav-login">
                             <b>LOG IN</b> 
                          </a>
  
                         
  
                          <a  href="#" class="nav-take-quiz">
                           SIGN {""}UP
                          </a>
                         
                          
                        
                         </div>
                      </div>
                      <div class="navbar-end">
                         <div class="navbar-item  navbar-item-costom">
                              
                                <div class="buttons">
                              
                                    <a class="button  is-primary">
                                      <strong> For  Schools</strong>
                                    </a>
                                    <a   className={this.state.linkclass}   href="#">
                                      Login
                                    </a>
                                   
                                    <div class=" navbar-end-costom">
                                      <a href="/home" class="nav-pay-quiz-moblie">
                                        START QUIZ
                                      </a>
                                    
                                      
                                    </div>
                                    
                                </div>
                            
                          
                          
                        </div>
                      </div>
                      
                    </nav>
  
                  }
  
            </div>
            :
            <div>
            {
              this.state.activeMenu?
             
              <div className="" > 
                    <div className="moblieside-fullbody-sub">
                        <div      style={{position:"relative",bottom:"20px",float:"right",height:"2px"}}>
                          <a
                                  onClick={this.toggleMenu}
                                  style={{position:"relative",bottom:"3%",}}
                                  className={`navbar-burger burger ${this.state.activeMenu ? 'is-active' : ''}`}
                              >
                    
                              
                              <span />
                              <span />
                              <span />
                          </a>
                        </div>
                         
                        <img src="https://res.cloudinary.com/codepally/image/upload/v1669803366/UFUON%20LOGO%20PNG/ufuon%20logo%20playstore/uf2_iiwvue.png" width="50" 
                          style={{position:"relative",bottom:"6px",left:"27px"}}
                        /> 
                       
                        <div className="nav-list-link">
                         <a href="/" > <p>Home</p>   </a>
                        </div>
                        
                        
                        <div className="nav-list-link">
                        <a href="#"> <p> SCHOOL</p> </a>
                        </div>
                        <div className="nav-list-link">
                        <a href="#" >  <p>CONTACT</p> </a>
                        </div>
                         


                   </div>
                </div>
                :
                <nav   className="navbar is-info is-fixed-top  nav-link-contom-login" role="navigation" aria-label="main navigation" >
    
                <div class="navbar-brand" >
                  <a class="navbar-item  navbar-item-img-cos" href="/">
                  
                    <img src="https://res.cloudinary.com/codepally/image/upload/v1669803366/UFUON%20LOGO%20PNG/ufuon%20logo%20playstore/uf2_iiwvue.png" width="" height=""/>
                  </a>
                  <NavbarBurger
                    active={this.state.activeMenu}
                    toggleMenu={this.toggleMenu}
                  />
                  
                </div>
                
                <div id="navbarBasicExample " class="navbar-menu nav-constom">
                  <div class="navbar-start">
                    <a  class="nav-create-buttom" onClick={this.clickModal}>
                      CREATE
                    </a>
                  <a class="nav-share-button" onClick={this.clickShare}>
                      SHARE
                    </a>
                       <a class="button is-link is-light navbar-userbutton" onClick={this.showProfile}>
                         <span class="icon is-small">
                         <i class="fas fa-user-circle"></i>
                          </span>
                          {
                              this.state.profile?
                              <span class="icon is-small">
                                <i class="fas fa-angle-down"></i>
                              </span>
                              :
                              <span class="icon is-small">
                                <i class="fas fa-angle-up"></i>
                              </span>
                          }
                          
                    
                      </a>
                    
                   
                   </div>
                  
                     
                </div>
                {
                  this.state.profile?
                  <div className="nav-profile-body">
                      <div className="nav-profile-sub">
                        <div className="nav-profile-p">
                            <p><b>whitetree</b></p>
                            <p>Setting</p>
                        </div>
                        <div className="nav-profile-p">
                            <p><b>  Heroes List International Science School</b></p>
                            <p>Upgread now</p>
                        </div>
                        <div className="nav-profile-p-out">
                            <p><i class="fas fa-sign-out-alt"></i> Signout</p>
                            
                        </div>
                      
                      </div>   
                </div>
                :
                ""
                }
                 
                <div class="navbar-end">
                   <div class="navbar-item  navbar-item-costom">
                        
                    
                        <div class="buttons">
                              <a class="button  is-primary">
                                <strong> Lesson</strong>
                              </a>
                              <a   className={this.state.linkclass} style={{fontSize:'15px',color:'#fff',marginLeft:'3%'}}   href="#">
                              Library
                              </a>
                             
                              <div class=" navbar-end-costom">
                                <a href="/home" class="nav-pay-quiz-moblie" style={{marginRight:'5%'}}>
                                  Enter Code
                                </a>
                                
                              </div>
                           </div> 
                     </div>
                  </div>
              </nav>
            }
            {
             this.state.showModal?
              <div class="trans-loader-Vendors">
                <div className="trans-pre-Vendors"> 
                  <a class="button is-danger" onClick={this.closeVendors} style={{float:"right",position:"relative",bottom:"10px"}}>
                      <span class="icon is-small">
                        <i class="fas fa-times"></i>
                      </span>
                   </a>
                 
                     <div  className="nav-body-create">
                        <a class="button is-large" href="/creator">
                            <span class="icon">
                            {/* <i class="far fa-question-circle"></i> */}
                              <i class="far fa-question-circle fa-lg"></i>
                            </span>
                          </a>
                          <a class="button is-large"  href="/new-article">
                            <span class="icon">
                            <i class="far fa-newspaper fa-lg"></i>
                              {/* <i class="fas fa-heading fa-lg"></i> */}
                            </span>
                          </a>
                                
                                
                    </div>
                          
               </div>
             </div>
             :
             ""
            }
            {
              this.state.shareMadal?
              <div class="trans-loader-Vendors">
              <div className="trans-pre-Vendors"> 
              <h1>
              Choose how to continue
              </h1>
                <a class="button is-danger" onClick={this.closeVendors} style={{float:"right",position:"relative",bottom:"10px"}}>
                    <span class="icon is-small">
                      <i class="fas fa-times"></i>
                    </span>
                 </a>
                   {
                     this.state.showQuiz  ?
                     <div  className="nav-body-create">
                       {
                         this.state.single?
                         <div>
                           <div>
                              <input class="input is-rounded" type="text" placeholder="Search Username"/>
                          </div>
                            <div>
                              <div className="pally-news-later">
                                    
                                    {/* <hr style={{background:"#000",position:"relative",bottom:"10px"}}/> */}
                                  <div className="nav-news-sub">
                                      <div className="nav-news-sub-img">
                                          <img src="data:image/png;base64,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"/>
                                      </div>
                                      <div className="nav-news-article">
                                        
                                          <p><b> Chichi obi </b></p>
                                          <p>
                                          Class : SS2
                                          
                                          </p>
                                      </div>
                                  </div>
                                </div>

                          </div>
                         </div>
                         :
                         <div>
                       <div className="nav-input-Search">
                          <input class="input is-rounded" type="text" placeholder="Search Quiz"/>
                       </div>
                         <div>
                            <div className="">
                                {
                                  this.state.MethodData?
                                  <a onClick={this.clickMethod}>
                                    <div className="nav-question-sub">
                                      <div className="nav-question-sub-img">
                                        <div className="nav-question-sub-title">
                                        <span >20 Questions</span>
                                        </div>
                                          {/* <img src="https://kahoot.com/files/2020/10/GameOptions_Blog-600x338.png"/> */}
                                      </div>
                                      <div className="nav-question-data">
                                         <p><b> Create awesome math kahoots with our new math </b></p>
                                            <div className="nav-question-total"> 
                                                <span  class="nav-question-total-span1">CodepallyStudio</span>
                                                <span class="nav-question-total-span2">17.1k plays</span>
                                            </div>
                                        </div>
                                     </div>
                                  </a>
                                  :
                                  <div className="nav-choose-which-body">
                                         <div className="nav-choose-which">
                                           <a onClick={this.clickSingle}>
                                             <img src="https://create.kahoot.it/v2/assets/dialog_enhanced-sharing_share.bd51fd9b.png"></img>
                                           </a>
                                           </div>
                                           <div className="nav-choose-which">
                                           <a onClick={this.clickEveryone}>
                                             <img src="https://create.kahoot.it/v2/assets/assign-challenge.2a11ce4d.svg"/>
                                           </a>
                                         </div>
                                  </div>
                                }
                                  
                                  {/* <a onClick={this.clickMethod}>
                                    <div className="nav-question-sub">
                                      <div className="nav-question-sub-img">
                                        <div className="nav-question-sub-title">
                                        <span >20 Questions</span>
                                        </div>
                                       
                                      </div>
                                      <div className="nav-question-data">
                                         <p><b> Create awesome math kahoots with our new math </b></p>
                                            <div className="nav-question-total"> 
                                                <span  class="nav-question-total-span1">CodepallyStudio</span>
                                                <span class="nav-question-total-span2">17.1k plays</span>
                                            </div>
                                        </div>
                                     </div>
                                  </a> */}
                                  
                                  
                                </div>  
                           </div>
                       
                         </div>
                       }
                      </div>
                       :
                       this.state. showArticle ?
                       <div  className="nav-body-create">
                       <div>
                          <input class="input is-rounded" type="text" placeholder="Search Articles"/>
                       </div>
                         <div>
                            <div className="pally-news-later">
                                
                                   {/* <hr style={{background:"#000",position:"relative",bottom:"10px"}}/> */}
                                  <div className="nav-news-sub">
                                      <div className="nav-news-sub-img">
                                          <img src="https://kahoot.com/files/2020/10/GameOptions_Blog-600x338.png"/>
                                      </div>
                                      <div className="nav-news-article">
                                         <p><b> Create awesome math kahoots with our new math </b></p>
                                         <p>
                                         Based on popular teacher requests, we’ve added a new math symbol
                                        
                                         and equations.. 
                                          
                                          </p>
                                      </div>
                                  </div>
                                  <div className="nav-news-sub">
                                      <div className="nav-news-sub-img">
                                          <img src="https://kahoot.com/files/2020/10/GameOptions_Blog-600x338.png"/>
                                      </div>
                                      <div className="nav-news-article">
                                         <p><b> Create awesome math kahoots with our new math </b></p>
                                         <p>
                                         Based on popular teacher requests, we’ve added a new math symbol
                                        
                                         and equations.. 
                                          
                                          </p>
                                      </div>
                                  </div>
                                </div>  
                         </div>
                       </div>
                     :
                     <div  className="nav-body-create">
                        <div class="columns">
                          <div class="column ">
                            <div className="nav-share-body">
                                  <img src="https://create.kahoot.it/v2/assets/dialog_enhanced-sharing_share.bd51fd9b.png"/>
                              <div  className="nave-share-sub">
                              <a  class="nav-share-button" onClick={this.clickQuiz}>
                                SHARE QUIZ
                              </a>
                              </div>
                            </div>
                          </div>
                          <div class="column">
                            <div className="nav-share-body">
                                  <img src="https://create.kahoot.it/v2/assets/dialog_enhanced-sharing_share.bd51fd9b.png"/>
                            <div>
                            <div  className="nave-share-sub">
                            <a  class="nav-share-button" onClick={this.clickArtilce}>
                                SHARE ARTICLE
                              </a>
                              </div>
                            </div>
                            </div>
                          </div>
                        </div>      
                      </div>  

                   }
                      
                </div>
              </div>
              :
              ""
            }
         

            

            </div>
        }
         
    </div>
    
    );
  }


    
}

export default  Navbar;



Navbar.propTypes = {
    pages: PropTypes.array.isRequired,
    color: PropTypes.string,
  };
    